import Channels from "../base/channels";
import Env from "../base/env";
import Component from "gia/Component";
import FilterActions from "../common/FilterActions";
import loadComponents from "gia/loadComponents";
import RevealGridItem from "../fx/RevealGridItem";
import RevealGridItemQuote from "../fx/RevealGridItemQuote";
import RevealGridItemEvent from "../fx/RevealGridItemEvent";

export default class Module extends Component {
  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.receptor = this.DOM.view.querySelector(".jsFilter--receptor");
    console.log();
    if (this.DOM.view.querySelector(".jsFilter--view") != null) {
      this.actions = new FilterActions(this.DOM.view);
      this.actions.setup();
    }

    this.fnGridUpdate = this.update.bind(this);
    Channels.on("grid::update", this.fnGridUpdate);
  }

  redrawScroll() {
    setTimeout(() => {
      if (typeof Env.framework.UI.smoothie != "undefined") {
        Env.framework.UI.smoothie.update();
      }
      //! Repos Scroll
      const getScrollPos =
        Env.framework.toolbox.scrollPosition().scrollY +
        this.DOM.view.getBoundingClientRect().top;
      if (Env.framework.toolbox.scrollPosition().scrollY > 0) {
        // window.scrollTo(0, getScrollPos - 100);
      }

      //! Redraw FX components
      setTimeout(() => {
        Env.framework.UI.lazy();
        loadComponents(
          {
            RevealGridItem: RevealGridItem,
            RevealGridItemQuote: RevealGridItemQuote,
            RevealGridItemEvent: RevealGridItemEvent,
          },
          this.DOM.receptor
        );
      }, 100);
    }, 150);
  }

  update() {
    this.redrawScroll();
  }

  unmount() {
    Channels.removeListener("grid::update", this.fnGridUpdate);
    if (typeof this.actions != "undefined") {
      this.actions.destroy();
    }
  }
}
